// @flow
import { createSelector } from 'reselect'
import { getList } from '../../modules/list/selectors'
import { ALL_NOTIFICATIONS } from './constants'
import { getDomain, type EntityMap } from '../../modules/entities/index'
import { domains } from '../constants'
import type { Notification } from './types'
import type { Selector } from '../../core/types'

export const getNotifications: Selector<Notification[]> = createSelector(
  getList(ALL_NOTIFICATIONS),
  getDomain(domains.NOTIFICATIONS),
  function getNotificationsTransfomer(
    ids: string[],
    byId: EntityMap<Notification>
  ) {
    return ids.map(id => byId[id])
  }
)

export const getFirstNotification = (
  ofTypes: number[]
): Selector<?Notification> =>
  createSelector(
    getList(ALL_NOTIFICATIONS),
    getDomain(domains.NOTIFICATIONS),
    function(ids: ?(string[]), byId: EntityMap<Notification>) {
      const notifications = (ids || [])
        .map(id => byId[id])
        .filter(
          notification =>
            ofTypes.length ? ofTypes.includes(notification.type) : true
        )
      return notifications ? notifications[0] : null
    }
  )



// WEBPACK FOOTER //
// ./src/services/notification/selectors.js